export const initializeOptions = ({ 
    idsOptionsThatHaveAlreadyBeenUsedToAnswer = [],
    answerOptions
}) => {
    return answerOptions?.filter((el) => !idsOptionsThatHaveAlreadyBeenUsedToAnswer.includes(el.id))
    .map((el) => ({...el, parrentId: null})) // parrentId добавляем, он используется в логике перетаскивания
}
// часть 1. в массив options помещаем только те варианты ответа, которые не использованы
// в ответе ранее(не помезены ни в одну корзину)
// часть 2 логики искать в basketsInitializer.js в этой же папке на этом же уровне